import zipcodeApi from '~/clientApis/zipcodeApi';
import { showMessageModal } from '~/clientUtils/showMessageModal';
import { ZipCodeRangeForService } from '~/definitions/zipcode';
import { getStore } from '~/mobx/AppStore';
import { ZipCodeParser } from '~/utils/zipCodeParser';

const addZipcode = async (zipCodesToAdd: ZipCodeRangeForService) => {
    const { zipcodeStore, regionStore } = getStore();
    const regionId = regionStore.selectedRegionId;
    const parsedExistingZipcode = ZipCodeParser.parse(zipcodeStore.selectedZipcode);
    const stringifiedZipcodeToAdd = ZipCodeParser.stringify([zipCodesToAdd]);
    const mergedZipcodeToUpdate = ZipCodeParser.addZipCodes(parsedExistingZipcode, stringifiedZipcodeToAdd);
    const stringifiedMergedZipcodeToUpdate = ZipCodeParser.stringify(mergedZipcodeToUpdate);
    const expandedRangesStr = ZipCodeParser.getExpandedRanges(stringifiedMergedZipcodeToUpdate).expandedRangesStr;
    const activeRangeId = ZipCodeParser.findZipcodeSegment(stringifiedZipcodeToAdd, expandedRangesStr);

    const params = {
        regionId: regionId,
        data: {
            value: stringifiedMergedZipcodeToUpdate,
        },
    };

    zipcodeStore.setIsGettingZipcode(true);

    try {
        await zipcodeApi.updateZipcode({ ...params });
        zipcodeStore.setSelectedZipcode(stringifiedMergedZipcodeToUpdate);
        zipcodeStore.setSelectedRangeId(activeRangeId);
        await zipcodeStore.getZipcodeListAndPagination();
    } catch (error) {
        showMessageModal('error', 'Error adding zipcode');
        throw error;
    } finally {
        zipcodeStore.setIsGettingZipcode(false);
    }
};

export default addZipcode;
